import React,{useState,useContext} from 'react';
import "../css/SignIn.css";
import logo from "../img/logo.png"
import { Link,useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginContext } from '../context/LoginContext';

export default function SignIn() {
  const {setUserLogin}=useContext(LoginContext)
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

// Toast Functions
const notifyA = (msg) => toast.error(msg)
const notifyB = (msg) => toast.success(msg)

const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

  const postData = () => {
    setLoading(true);
    // checking email
    if (!emailRegex.test(email)){
      setLoading(false);
        notifyA("Invalid Email")
        return
    }
    // Sending data to server
    fetch("/signin",{
        method:"post",
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            email:email,
            password:password

        })
    })
    .then(async (res) => {
      if (!res.ok) {
        // Common case: wrong credentials
        if (res.status === 401) {
          setLoading(false);
          notifyA('Incorrect Email or Password');
          return null;
        }
        // try to read error message from body
        try {
          const errBody = await res.json();
          setLoading(false);
          notifyA(errBody.error || 'Sign in failed');
        } catch (e) {
          setLoading(false);
          notifyA('Sign in failed');
        }
        return null;
      }
      return res.json();
    })
    .then(data =>{
      if (!data) return;
      setLoading(false);
      if(data.error){
        notifyA(data.error)
      }else{
        notifyB("Signed In Successfully")
        console.log(data)
        localStorage.setItem("jwt",data.token)
        localStorage.setItem("user",JSON.stringify(data.user) )

        setUserLogin(true)
        try { window.dispatchEvent(new CustomEvent('user-changed')); } catch(e){}
        navigate("/")
      }
      console.log(data)
    }).catch(err => { setLoading(false); notifyA('Network error'); console.error(err); });
  }

  return (
  <div className='signIn'>
    <div>
      <div className="loginForm">
        <img className='signUpLogo' src={logo} alt="" />
        <h1 className='appNameLogin'>Linkalikes</h1>
        <p className='pointLine' style={{marginTop:"-22px"}}>Only for LIVING beings!!</p>
        <div style={{backgroundColor:"black", borderRadius:"15px", padding:"15px"}} className="backForm">
          <div>
            <input className='mainInputsLogin' type="email" name="email" id='email' value={email} placeholder='Email' onChange={(e) => { setEmail(e.target.value) }} maxLength={120} />
          </div>
          <div>
          <input 
            type="password" 
            name="password" 
            id='password' 
            placeholder='Password'
            value={password}
            onChange={(e)=>{setPassword(e.target.value.slice(0,120))}}
            className='mainInputsLogin'
            maxLength={120}
          />
          </div>
          <button type="button" id='login-btn' onClick={postData} disabled={loading}>
            {loading ? <span className="btn-spinner" /> : 'Login'}
          </button>
        </div>
        <hr />
        <p style={{backgroundColor:"black", color:"white", display:"inline-block"}}>Don't have an account ?</p>
        <Link to="/signup">
          <span style={{color:'yellow', backgroundColor:"black", cursor:'pointer'}}> Sign Up</span>
        </Link>
        <br />
        <div style={{ backgroundColor:"black", display:"flex", flexDirection:"column", alignItems:"center", marginTop:"10px", width:"100%"}}>
          <p>a <b>Subodh Sathe</b> creation</p>
          <b>Linkalikes &copy; 2026</b>

          <a href="/support" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block'}}>Contact Us</a>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block'}}>Privacy Policy</a>
          <a href="/csae-standards" target="_blank" rel="noopener noreferrer" style={{color:'yellow', backgroundColor:"black", textDecoration:"underline", marginTop:6, display:'inline-block', marginBottom:"15px"}}>CSAE Standards</a>

        </div>
      </div>
      {/* <div className="loginForm2">
      </div> */}
    </div>
  </div>
  );
}
